var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueMarkdown',{staticClass:"clpp-markdown",attrs:{"typographer":false,"lang-prefix":"language-","breaks":false,"source":_vm.resolvedContent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }